import { useState } from "react";
import {
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Paper,
  Typography,
  Divider,
  Chip,
  Button,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { useStore } from "../../context/StoreContext";
import { api } from "../../hooks/apiClient";
import { useSnackbar } from "notistack";
const BarcodeScanner = () => {
  const { selectedStore, isStoreSelected } = useStore();
  const store_id = isStoreSelected && selectedStore.id;
  const { enqueueSnackbar } = useSnackbar();
  const [orderIDS, setOrderIDS] = useState([]);
  const [orderNames, setOrderNames] = useState([]);
  const [orderCNS, setOrderCNS] = useState([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({
    id: "",
    name: "",
    cn: "",
  });

  const handleKeyDown = (field) => (e) => {
    if (e.key === "Enter") {
      const value = e.target.value.trim();
      if (value) {
        handleAddItem(field, value);
        setInputs((prev) => ({ ...prev, [field]: "" }));
      }
    }
  };
  const handleChange = (field) => (e) => {
    setInputs((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleAddItem = (field, value) => {
    const timestamp = new Date().toLocaleTimeString();
    // const id = Date.now();
    // const newItem = { id, value, timestamp };
    switch (field) {
      case "id":
        // setOrderIDS((prev) => {
        //   const isDuplicate = prev.some((item) => item.value === value);
        //   if (isDuplicate) {
        //     alert("Duplicate value not allowed in IDs");
        //     return prev;
        //   }
        //   return [...prev, newItem];
        // });
        setOrderIDS((prev) => [
          ...prev,
          {
            id: Date.now(),
            value,
            timestamp,
          },
        ]);
        break;
      case "name":
        setOrderNames((prev) => [
          ...prev,
          {
            id: Date.now(),
            value,
            timestamp,
          },
        ]);
        break;
      case "cn":
        setOrderCNS((prev) => [
          ...prev,
          {
            id: Date.now(),
            value,
            timestamp,
          },
        ]);
        break;
      default:
        break;
    }
  };

  const handleClearList = (field) => {
    setData(null);
    switch (field) {
      case "id":
        setOrderIDS([]);
        break;
      case "name":
        setOrderNames([]);
        break;
      case "cn":
        setOrderCNS([]);
        break;
      default:
        break;
    }
  };

  const sumbitOrders = async () => {
    try {
      setLoading(true);
      const ids = orderIDS.map((item) => item.value);
      const id_name = orderNames.map((item) => item.value);
      const response = await api.post(`orders/cancel/${store_id}`, {
        order_ids: ids,
        order_names: id_name,
      });

      setData(response.data);

      enqueueSnackbar("Store cancel order requsted  ...", {
        variant: "success",
      });
    } catch (error) {
      setData(error.response.data);

      enqueueSnackbar("Store does not have any orders. See the log.", {
        variant: "warning",
      });
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Paper elevation={3} sx={{ p: 2, maxWidth: 900, mx: "auto", mt: "5px" }}>
      <Typography variant="h6" gutterBottom>
        Order Management Scanner
      </Typography>

      {/* Scanner Input Fields */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2,
          mb: 3,
        }}
      >
        <TextField
          label="Order ID"
          variant="outlined"
          value={inputs.id}
          onChange={handleChange("id")}
          onKeyDown={handleKeyDown("id")}
          fullWidth
          autoFocus
        />
        <TextField
          label="Order Name"
          variant="outlined"
          value={inputs.name}
          onChange={handleChange("name")}
          onKeyDown={handleKeyDown("name")}
          fullWidth
        />
        <TextField
          label="Customer Number"
          variant="outlined"
          value={inputs.cn}
          onChange={handleChange("cn")}
          onKeyDown={handleKeyDown("cn")}
          fullWidth
        />
      </Box>

      {/* Scanned Items Lists */}
      <Box
        sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 2 }}
      >
        {/* Order IDs List */}
        <ScannedItemsSection
          title="Order IDs"
          items={orderIDS}
          onClear={() => handleClearList("id")}
          color="primary"
        />

        {/* Order Names List */}
        <ScannedItemsSection
          title="Order Names"
          items={orderNames}
          onClear={() => handleClearList("name")}
          color="secondary"
        />

        {/* Customer Numbers List */}
        <ScannedItemsSection
          title="Customer Numbers"
          items={orderCNS}
          onClear={() => handleClearList("cn")}
          color="success"
        />
      </Box>
      {!data ? (
        <Button
          sx={{ mt: "5px" }}
          variant="outlined"
          onClick={sumbitOrders}
          disabled={loading}
        >
          Submit
        </Button>
      ) : (
        <Typography>{data}</Typography>
      )}
    </Paper>
  );
};

// Reusable component for each scanned items section
const ScannedItemsSection = ({ title, items, onClear, color }) => (
  <Box
    sx={{
      border: "1px solid #eee",
      borderRadius: 1,
      maxHeight: 700,
      overflow: "auto",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 2,
        bgcolor: "#f5f5f5",
      }}
    >
      <Typography variant="subtitle1">
        {title} <Chip label={items.length} size="small" color={color} />
      </Typography>
      <IconButton
        onClick={onClear}
        disabled={items.length === 0}
        aria-label={`clear ${title}`}
        size="small"
      >
        <ClearIcon fontSize="small" />
      </IconButton>
    </Box>

    {items.length > 0 ? (
      <List dense>
        {[...items].reverse().map((item) => (
          <ListItem key={item.id} divider>
            <ListItemText
              primary={item.value}
              secondary={`${item.timestamp}`}
            />
          </ListItem>
        ))}
      </List>
    ) : (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          p: 3,
          color: "text.secondary",
        }}
      >
        <Typography variant="body2">
          No {title.toLowerCase()} scanned yet
        </Typography>
      </Box>
    )}
  </Box>
);

export default BarcodeScanner;
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// import OrderDetail from "../components/OrderDetails";

// import SyncProblemIcon from "@mui/icons-material/SyncProblem";
// import { useStore } from "../authContext/StoreContext";
// import {api} from  "../hooks/apiClient";
// import { useSnackbar } from "notistack";
// const OrdersProcessing = () => {
//   const navigate = useNavigate();
//   const { enqueueSnackbar } = useSnackbar();
//   const { selectedStore, isStoreSelected } = useStore();
//   const store_id = isStoreSelected && selectedStore.id;
//   const [order, setOrder] = useState(null);
//   const [orderIDS, setOrderIDS] = useState([]);
//   const [orderNames, setOrderNames] = useState([]);
//   const [orderCNS, setOrderCNS] = useState([]);
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [open, setOpen] = useState(false);
//   const ToggleOpen = () => {
//     setOpen(!open);
//   };
//   useEffect(() => {
//     GetOrders();
//   }, [store_id]);
//   async function GetOrders() {
//     try {
//       setLoading(true);

//       const response = await api.post(`orders/cancel/${store_id}`, {
//         order_ids: orderIDS,
//         order_names: orderNames,
//         cns: orderCNS,
//       });

//       setData(response.data);

//       enqueueSnackbar("Store does not have any orders ...", {
//         variant: "success",
//       });
//     } catch (error) {
//       setData([]);

//       enqueueSnackbar("Store does not have any orders. See the log.", {
//         variant: "warning",
//       });
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   }

//   const ViewOrder = async (id) => {
//     try {
//       const response = await api.get(`orders/finddetails/${id}`, {});
//       const order = response.data;

//       setOrder(order.line_items);

//       ToggleOpen();
//     } catch (error) {
//       console.error(error);
//     }
//   };
//   const ViewOrderDetails = async (id) => {
//     navigate(`/orders/${id}`);
//   };
//   const OrdersForBooking = async (store_id) => {
//     navigate(`/orders/booking`);
//   };
//   if (!isStoreSelected) {
//     return (
//       <div>
//         <SyncProblemIcon />
//         {!isStoreSelected && <p>No Store Selected</p>}
//       </div>
//     );
//   }
//   return (
//     <div>
//       <OrderDetail open={open} ToggleOpen={ToggleOpen} data={order} />
//     </div>
//   );
// };

// export default OrdersProcessing;
